import type { V2ShopDeploymentRouter } from "replo-publisher/src/trpc/routers/v2ShopDeployment";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: v2ShopDeploymentRouter,
  client: v2ShopDeploymentClient,
  utils: v2ShopDeploymentUtils,
  options: v2ShopDeploymentOptions,
} = createTrpcRouterConfig<V2ShopDeploymentRouter>({
  path: "v2ShopDeployment",
  queryClient: getNamespacedQueryClient("v2ShopDeployment"),
});

export {
  v2ShopDeploymentClient,
  v2ShopDeploymentRouter,
  v2ShopDeploymentUtils,
  v2ShopDeploymentOptions,
};
